<template>
  <div class="flex flex-col items-center justify-center">
    <graphic-base width="80" height="80" view-box="0 0 100 100">
      <circle-check />
    </graphic-base>
    <div
      class="text-center w-2/3 lg:w-6/12 my-12"
      :style="[firstLoginCustomParamsFields.styles.form.textColor]"
    >
      <h1 class="text-zt-lg mb-3 font-bold">
        {{ $t('message.resetPassComponent.successTitle') }}
      </h1>
      <div
        class="text-zt-dark-400"
        :style="[firstLoginCustomParamsFields.styles.form.textColor]"
      >
        <p>{{ $t('message.resetPassComponent.successMsg') }}</p>
      </div>
    </div>
    <div class="mb-4 w-full">
      <zt-button
        class="w-full opacity-100"
        :style="[firstLoginCustomParamsFields.styles.form.buttons.bgColor]"
        @click="gotoLogin"
        data-vs-button="auth-resetpass-success-btn-gotologin"
      >
        {{ $t('message.loginComponent.forgetPassword.goBack') }}
      </zt-button>
    </div>
  </div>
</template>

<script>
import GraphicBase from '@/components/commons/Illustrations/graphicBase'
import CircleCheck from '@/components/commons/Illustrations/graphicSVG/circleCheck'
export default {
  name: 'ztAuthResetPassSuccess',
  components: { CircleCheck, GraphicBase },
  props: {
    firstLoginCustomParamsFields: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    gotoLogin() {
      this.$router.replace({ name: 'login' })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .zt-button {
  height: 3.25rem;
}
</style>
